module.exports = __webpack_public_path__ + "static/media/checkCircleLargeIcon-2x.157d170f.png";